import React from 'react';
import styled from 'styled-components';
import Fachada from '../assets/fachada.png';
import { FaWhatsapp } from 'react-icons/fa';

const HeroContainer = styled.div`
  background: linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.1)), url(${Fachada});
  height: 100vh;
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center; /* Alterado para 'center' */
  padding: 0 30px; /* Padding padrão para todas as telas */
  color: #fff;
  text-align: center; /* Garante que o texto dentro do container seja centralizado */
  filter: brightness(1.2);
`;

const HeroContent = styled.div`
  max-width: 700px; /* Aumentei um pouco a largura máxima para o texto */
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center; /* Alinha os itens (título, parágrafo, botão) no centro */
`;

const HeroH1 = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);

  @media screen and (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const HeroP = styled.p`
  font-size: 1.5rem;
  margin-bottom: 2rem;
  font-weight: 400;

  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const HeroBtnWrapper = styled.div`
  display: flex;
  justify-content: center; /* Centraliza o botão dentro do seu wrapper */
`;

const Button = styled.a`
  border-radius: 50px;
  background: #c77408;
  white-space: nowrap;
  padding: 14px 48px;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c77408;
  }
`;

const Hero = () => {
  return (
    <HeroContainer id="hero">
      <HeroContent>
        <HeroH1>Oficina Primeira Linha</HeroH1>
        <HeroP>Somos mais que uma empresa de oficina veicular; somos parceiros de confiança na estrada.</HeroP>
        <HeroBtnWrapper>
          <Button href="https://api.whatsapp.com/send?phone=556232843050" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp style={{ marginRight: '8px' }} /> Fazer Orçamento
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
}

export default Hero;